import { render } from "./EventCard.vue?vue&type=template&id=6632d748"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__